export default function ConfirmationContentPropsCollector() {
  return null;
}

ConfirmationContentPropsCollector.displayName = "Confirmation.Content";
